import { BoxProps, TextProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const defaultStyles: any = {
  greenStatus: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  redStatus: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  orangeStatus: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  greyStatus: {
    backgroundColor: Colors.GREY_EB,
    color: Colors.GREY_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  blueStatus: {
    backgroundColor: Colors.BLUE_BG_C,
    color: Colors.BLUE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  blueBigStatus: {
    backgroundColor: Colors.BLUE_BG_C,
    color: Colors.BLUE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 120,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  blueOrangeStatus: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    alignItems: 'center',
    flex: 1,
    borderRadius: 2,
    maxWidth: 120,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
}

export const freezedColumnStyle = (width: number) => {
  return {
    position: 'sticky',
    zIndex: 10,
    left: 0,
    margin: 0,
    padding: 0,
    minWidth: width,
    height: '100%',
    backgroundColor: 'WHITE',
  } as BoxProps
}

export const styles: any = {
  success: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  failed: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  accepted: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  paused: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  active: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  scheduled: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  completed: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  complete: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  'in progress': {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  pending: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  paid: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  expired: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  issued: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  cancelled: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  inprocess: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  api: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  manual: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  deleted: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  blocked: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  inactive: {
    ...defaultStyles.greyStatus,
  } as BoxProps,
  defaultCell: {
    justifyContent: 'center',
    underlayColor: 'TRANSPARENT',
    paddingVertical: 16,
  } as BoxProps,
  canceled: {
    ...defaultStyles.redStatus,
  } as BoxProps,
  initiated: {
    ...defaultStyles.greenStatus,
  } as BoxProps,
  in_process: {
    ...defaultStyles.blueStatus,
  } as BoxProps,
  titleView: {
    opacity: 0.88,
    paddingVertical: 16,
    paddingHorizontal: 16,
  } as BoxProps,
  title: {
    fontSize: 12,
    color: 'BLACK_21',
    flexShrink: 1,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  titleheaderView: {
    flexDirection: 'row',
  } as BoxProps,
  titleHeader: {
    color: 'BLACK_21',
    fontSize: 12,
    textTransform: 'capitalize',
    fontFamily: 'jioType-bold',
  } as TextProps,
  linkStyle: {
    color: 'BLUE',
    fontSize: 12,
    // textAlign: 'center',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  in_progress: {
    ...defaultStyles.blueOrangeStatus,
  } as BoxProps,
  confirmed: {
    ...defaultStyles.orangeStatus,
  } as BoxProps,
  rootContainer: (height?: number) =>
    ({
      flexDirection: 'row',
      w: '100%',
      h: height ?? '100%',
      borderWidth: 1,
      borderColor: 'GRAY_BORDER',
      borderRadius: 4,
      flexGrow: 1,
      alignContent: 'center',
    } as BoxProps),
}
